import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const galleryItems = [
  {
    src: "https://customer-assets.emergentagent.com/job_somatic-reels-hub/artifacts/3bzvrnx3_honey-dip.jpg",
    title: "Divine Flow",
    year: "2024",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_somatic-reels-hub/artifacts/9dd3gy2v_IMG_1956.jpg",
    title: "Divine Flow",
    year: "2024",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_somatic-reels-hub/artifacts/yzucn7h9_IMG_3007_Original.JPG",
    title: "Divine Flow",
    year: "2025",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_somatic-reels-hub/artifacts/gj3tn1j4_IMG_3290_Original.JPG",
    title: "Divine Flow",
    year: "2025",
  },
];

const DivineFlowGallery = () => {
  const [active, setActive] = useState(0);

  const prev = () => setActive(active === 0 ? galleryItems.length - 1 : active - 1);
  const next = () => setActive(active === galleryItems.length - 1 ? 0 : active + 1);

  const item = galleryItems[active];

  return (
    <section data-testid="divine-flow-gallery" className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto">
      <div className="mb-12">
        <p className="text-xs uppercase tracking-[0.25em] text-[#596B5B] mb-3 font-medium">
          Workshop Gallery
        </p>
        <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light text-[#1A3626] tracking-tight">
          Afro Cuban Dance Workshop
        </h2>
        <p className="mt-4 text-sm text-[#596B5B] max-w-lg leading-relaxed">
          A collaboration with community wellness practitioners in "Divine Flow" &mdash; a day retreat celebrating movement, culture, and healing.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
        {/* Image */}
        <div className="relative overflow-hidden rounded-lg">
          <img
            data-testid={`gallery-item-${active}`}
            src={item.src}
            alt={`${item.title} ${item.year}`}
            className="w-full h-[400px] md:h-[500px] object-contain transition-all duration-500"
            loading="lazy"
          />
        </div>

        {/* Content & Nav */}
        <div>
          <h3 className="font-['Cormorant_Garamond'] text-3xl md:text-4xl font-light text-[#1A3626] mb-4 tracking-tight">
            {item.title}
          </h3>
          <p className="text-xs uppercase tracking-[0.2em] text-[#596B5B] font-medium">
            {item.year}
          </p>

          {/* Navigation */}
          <div className="flex items-center gap-4 mt-8">
            <button
              data-testid="gallery-prev-btn"
              onClick={prev}
              className="w-10 h-10 rounded-full border border-[#DCD6CC] flex items-center justify-center text-[#596B5B] hover:bg-[#EBE6DF] hover:text-[#1A3626] transition-all"
            >
              <ChevronLeft size={18} />
            </button>
            <span className="text-xs text-[#596B5B] tracking-wider">
              {active + 1} / {galleryItems.length}
            </span>
            <button
              data-testid="gallery-next-btn"
              onClick={next}
              className="w-10 h-10 rounded-full border border-[#DCD6CC] flex items-center justify-center text-[#596B5B] hover:bg-[#EBE6DF] hover:text-[#1A3626] transition-all"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DivineFlowGallery;
